import { render, staticRenderFns } from "./ClosableWrapper.vue?vue&type=template&id=6fdbe6a6&"
import script from "./ClosableWrapper.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClosableWrapper.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ClosableWrapper.vue?vue&type=style&index=0&id=6fdbe6a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports